export const DASHBOARD_CONFIG_PATH = 'v1/health-dashboard-configs';
